import { colors } from '@core/assistant/colors';
import { fontStyle } from 'html2canvas/dist/types/css/property-descriptors/font-style';

export const useStyles = () => {
  return {
    box: {
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
      height: 458,
      overflow: 'auto',
      paddingRight: 1,

      '&::-webkit-scrollbar': {
        height: '5px',
        width: '5px',
      },

      '&::-webkit-scrollbar-track': {
        backgroundColor: colors.silver,
        borderRadius: '2px',
      },

      '&::-webkit-scrollbar-thumb': {
        backgroundColor: colors.blue_second,
        borderRadius: '2px',
        boxShadow: 'unset',
      },
    },
    awaitingResponse: {
      display: 'flex',
      alignItems: 'center',

      smsIcon: {
        fontSize: '2.5rem',
      },
      text: {
        color: colors.white,
        marginTop: '-7px',
        marginLeft: '5px',
        fontSize: '15px',
      },
    },
    feedback: {
      fontSize: 12,
      marginTop: '10px',

      svg: {
        fontSize: 24,
        marginTop: '8px',

        '&:first-of-type': {
          marginRight: '10px',
        },
        '&:hover': {
          color: colors.white,
          cursor: 'pointer',
        },
      },
    },
  };
};
